import React from "react";

export interface IStreamLinkProps {
  label: string;
  url: string;
  target: string;
}

const SitemapLink = ({ label, url, target }: IStreamLinkProps) => (
  <li data-testid="route">
    <a
      href={url}
      target={target}
      className="font-secondary leading-[1.8] text-grey-700 font-medium text-[14px]"
    >
      {label}
    </a>
  </li>
);

export default SitemapLink;
